import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { SelectField } from '@monorepo/shared/componentsV2/fields/SelectField';
import type { SelectOption } from '@monorepo/shared/componentsV2/Select/Select';
import { isRequired } from '@monorepo/shared/utils/validators';
import {
  FormConditionalOperator,
  isOperatorAllowedForFieldType,
  SortedFormConditionalOperators,
} from 'mapistry-shared';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { EditableFormTemplateField } from '../types';

const OPERATOR_FIELD_NAME = 'operator';

export const OPERATOR_LABELS: Record<FormConditionalOperator, string> = {
  [FormConditionalOperator.BLANK]: 'Is empty',
  [FormConditionalOperator.NOT_BLANK]: 'Is not empty',
  [FormConditionalOperator.EQUAL]: 'Is',
  [FormConditionalOperator.NOT_EQUAL]: 'Is not',
  [FormConditionalOperator.CONTAINS]: 'Contains',
  [FormConditionalOperator.DOES_NOT_CONTAIN]: 'Does not contain',
};

const StyledSelect = styled(SelectField)`
  width: 20%;
`;

type OperatorSelectProps = {
  triggerField: EditableFormTemplateField;
  rulePrefix: string;
};

export function ConditionalOperatorPicker({
  triggerField,
  rulePrefix,
}: OperatorSelectProps) {
  const operatorFieldName = getFieldNameWithPrefix(
    OPERATOR_FIELD_NAME,
    rulePrefix,
  );

  const options = useMemo<SelectOption[]>(
    () =>
      SortedFormConditionalOperators.filter((operatorOption) =>
        isOperatorAllowedForFieldType(operatorOption, triggerField.type),
      ).map((operatorOption) => ({
        label: OPERATOR_LABELS[operatorOption],
        value: operatorOption,
      })),
    [triggerField.type],
  );

  return (
    <StyledSelect
      placeholder="Choose one"
      name={operatorFieldName}
      label="If this field"
      options={options}
      validate={isRequired}
    />
  );
}
